import {
  declareString,
  declareStringWithPlaceholders,
} from "@1js/localization";

export const ShareToTeamTitle = declareString(
  "promptLibrary.shareToTeamTitle",
  {
    text: "Share a copy of this prompt to a team",
    comment: "Dialog title to share a prompt to a team.",
  }
);

export const ShareToTeamExplanation = declareString(
  "promptLibrary.shareToTeamExplanation",
  {
    text: "Everyone in the team will be able to view or delete it.",
    comment: "Explanation below the dialog title to share a prompt to a team.",
  }
);

export const ShareToTeamTeamsLabel = declareString(
  "promptLibrary.shareToTeamTeamsLabel",
  {
    text: "Share to",
    comment: "Dropdown label to select a team.",
  }
);

export const ShareToTeamTeamsDropdownPlaceholder = declareString(
  "promptLibrary.shareToTeamTeamsDropdownPlaceholder",
  {
    text: "Select or enter a team name",
    comment: "Dropdown label to select a team.",
  }
);

export const ShareToTeamCancelButtonLabel = declareString(
  "promptLibrary.shareToTeamCancelButtonLabel",
  {
    text: "Cancel",
    comment: "Button label to cancel sharing a prompt to a team.",
  }
);

export const ShareToTeamShareButtonLabel = declareString(
  "promptLibrary.shareToTeamShareButtonLabel",
  {
    text: "Share",
    comment: "Button label to share a prompt to a team.",
  }
);

export const CloseTooltip = declareString("promptLibrary.closeTooltip", {
  text: "Close",
  comment: "Tooltip text for close button.",
});

export const LearnHowToCreateATeamLink = declareString(
  "promptLibrary.learnHowToCreateATeamLink",
  {
    text: "Learn how to create a team",
    comment: "Link to help article on how to create a team",
  }
);

export const NotifyTeamMembersCheckboxLabel = declareString(
  "promptLibrary.notifyTeamMembersCheckboxLabel",
  {
    text: "Notify team members",
    comment:
      "Checkbox label to notify team members; displayed when no team has been selected yet.",
  }
);

export const NotifyTeamMembersWithCountCheckboxLabel =
  declareStringWithPlaceholders(
    "promptLibrary.notifyTeamMembersWithCountCheckboxLabel",
    {
      text: ({ count }) => `Notify team members (${count})`,
      placeholders: {
        count: "the number of team members within the selected teams",
      },
      comment:
        "Checkbox label to notify team members; displayed when one or more teams have been selected and a count of members in those teams is known.",
    }
  );
